module.exports = __webpack_public_path__ + "static/media/react.eab76719.svg";